module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/timeBird_4a4427.png";